import Details from '_AFIS_/components/pages/Details';
import DownloadHoldings from '_AFIS_/components/QuarterlyHoldingsComponents/DownloadHoldingsFullscreen';
import NotFound from '_AFIS_/components/pages/NotFound';
import QuarterlyHoldings from '_AFIS_/components/pages/QuarterlyHoldings';
import Returns from '_AFIS_/components/pages/Returns';
import Root from '../Root.vue';
import { createRouter, createWebHistory } from 'vue-router';
import { AssetTypesFormat, ObjectivesFormat, ShareClassesFormat, TimeSpanFormat } from '../shared/utils/format';
import { getParameterCaseInsensitive } from '../shared/utils/utils';

const router = createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: '/:audience/investments',
      name: 'Home',
      component: Root, // Parent component
      children: [
        {
          //the :h technically saves what comes after the 'insurance-funds' into the route params, while its not used, this syntax is necessary to match with and without ".htm" at the end
          path: 'insurance-funds:h(.htm)?',
          name: 'Returns',
          component: Returns,
          props: returnsRouteParams
        },
        {
          path: 'insurance-funds/quarterly-holdings/:vehicleId',
          name: 'Quarterly-Holdings',
          component: QuarterlyHoldings
        },
        {
          path: 'insurance-funds/download-holdings/:vehicleId',
          name: 'Download Holdings',
          component: DownloadHoldings
        },
        {
          path: 'insurance-funds/:vehicleId',
          name: 'Details',
          component: Details
        }
      ]
    },
    {
      path: '/not-found/404',
      name: 'Not-Found',
      component: NotFound,
      props: true
    },
    {
      path: '/:catchAll(.*)',
      redirect: '/not-found/404'
    }
  ]
});

function returnsRouteParams(route) {
  const queryValuesSafe = {};
  const queryKeysLowercase = ['objectives', 'assettypes', 'shareclass', 'timespan', 'showindices'];

  queryKeysLowercase.forEach(qKey => {
    if (route.query) {
      queryValuesSafe[qKey] = getParameterCaseInsensitive(route.query, qKey);
    }
  });

  const objectives = queryValuesSafe.objectives && queryValuesSafe.objectives.split(',').map(objective => ObjectivesFormat[objective.toLowerCase()]);
  const assetTypes = queryValuesSafe.assettypes && queryValuesSafe.assettypes.split(',').map(objective => AssetTypesFormat[objective.toLowerCase()]);
  const shareClass = queryValuesSafe.shareclass && ShareClassesFormat[queryValuesSafe.shareclass.toLowerCase()];
  const timeSpan = queryValuesSafe.timespan && TimeSpanFormat[queryValuesSafe.timespan.toLowerCase()];
  const showIndices = queryValuesSafe.showindices === 'true';

  return {
    routeParams: {
      objectives,
      assetTypes,
      shareClass,
      timeSpan,
      showIndices
    }
  };
}

router.beforeEach((to, from, next) => {
  if (to.name === 'Download Holdings') {
    next({ name: 'Not-Found' });
  }
  next();
});


export default router;
